module.exports = __webpack_public_path__ + "static/media/up.14525884.svg";